import { Building2, Boxes, Users, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Overline, SectionHeading } from "@/components/Section";

function TreeNode({ label, sub, tone = "amber", testid }) {
  const tones = {
    amber: "border-tib-amber/50 text-tib-amber",
    blue: "border-tib-blue/50 text-tib-blue",
    mint: "border-tib-mint/50 text-tib-mint",
    zinc: "border-zinc-700 text-zinc-400",
  };
  return (
    <div data-testid={testid} className={`card-edge px-6 py-5 text-center border ${tones[tone]}`}>
      <div className="text-white font-semibold">{label}</div>
      {sub && <div className="text-xs text-zinc-500 mt-1 font-mono uppercase tracking-widest">{sub}</div>}
    </div>
  );
}

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="section-pad border-b border-zinc-900">
        <div className="container-tib">
          <SectionHeading
            overline="The hierarchy"
            title="One holding company. One build engine. Many platforms."
            body="TechInnovationBuilders is the operating division of MPGBusinessFunding.com. We build and operate internal, MPGBF-owned platforms — and we build external platforms under contract. External clients keep ownership of their assets, or partner with TIB to operate them. Either way, we build your dream and stand behind it."
          />
        </div>
      </section>

      {/* TREE */}
      <section className="section-pad">
        <div className="container-tib max-w-4xl mx-auto flex flex-col items-center gap-8" data-testid="company-tree">
          <TreeNode label="MPGBusinessFunding.com, LLC" sub="Parent holding company" tone="blue" testid="tree-mpgbf" />
          <div className="w-px h-8 bg-zinc-800" />
          <TreeNode label="TechInnovationBuilders.com, LLC" sub="Building / operating division" tone="amber" testid="tree-tib" />
          <div className="w-px h-8 bg-zinc-800" />
          <div className="grid md:grid-cols-2 gap-8 w-full">
            <div className="space-y-4">
              <Overline className="text-center block">Internal — owned by MPGBF</Overline>
              <TreeNode label="IdeaDepot.ai" sub="LIVE" tone="mint" testid="tree-ideadepot" />
              <TreeNode label="FounderDevMatch.com" sub="Coming soon" tone="zinc" />
              <TreeNode label="TrustClose.com" sub="Coming soon" tone="zinc" />
              <TreeNode label="+ 17 more in build" sub="See portfolio" tone="zinc" />
            </div>
            <div className="space-y-4">
              <Overline className="text-center block">External — client-owned</Overline>
              <TreeNode label="Client platform slot" sub="Open" tone="zinc" />
              <TreeNode label="Client platform slot" sub="Open" tone="zinc" />
            </div>
          </div>
        </div>
      </section>

      {/* PILLARS */}
      <section className="section-pad bg-tib-ink border-y border-zinc-900">
        <div className="container-tib grid md:grid-cols-3 gap-6">
          {[
            { icon: Building2, t: "Internal builds", d: "Platforms TIB builds for MPGBF are owned by the holding company and maintained by TIB — assets on the balance sheet, not invoices." },
            { icon: Boxes, t: "Operated by TIB", d: "We don't hand off and vanish. TIB runs infrastructure, growth, and revenue for the platforms it builds and manages." },
            { icon: Users, t: "Your builds, your call", d: "Commission a TIB build and keep full ownership of your assets — or partner with TIB to operate and grow them for you." },
          ].map((p) => (
            <div key={p.t} className="card-edge p-8" data-testid={`pillar-${p.t.split(" ")[0].toLowerCase()}`}>
              <p.icon className="w-7 h-7 text-tib-gold" strokeWidth={1.3} />
              <h3 className="h-serif text-2xl text-white mt-5">{p.t}</h3>
              <p className="text-zinc-400 mt-3 leading-relaxed">{p.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section-pad text-center">
        <div className="container-tib">
          <h2 className="h-serif text-4xl md:text-5xl text-white max-w-2xl mx-auto">Want to become part of the tree?</h2>
          <Link to="/clients/apply" className="btn-primary mt-8 inline-flex" data-testid="about-cta">
            Apply to build <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
